import React, { useEffect } from "react";

export default function DownloadRedirect() {
  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor;

    if (/iPad|iPhone|iPod/.test(ua)) {
      // Redirect iOS users
      window.location.href =
        "https://apps.apple.com/app/id6753561309";
    } else {
      // Android: not on Google Play — send everyone else to the website
      // Fallback: show website or default download page
      window.location.href = "https://groundrounds.app";
    }
  }, []);

  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      <h2>Redirecting to the right app store...</h2>
      <p>If nothing happens, <a href="https://groundrounds.app">click here</a>.</p>
    </div>
  );
}
